import "./Contact.module.css";
import Naglowek from "@/reusable_sections/Header";
import Contacts from "./sections/Contacts";
import StopkaDworu from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Naglowek />
      <Contacts />
      <StopkaDworu />
    </div>;
}